import { BaseChartSettings } from "app/shared/model/charts/user-analytic-configurations.model";
import { ChartTypeRegistry, Plugin } from "chart.js";
import { AnyObject } from "chart.js/dist/types/basic";

export const CustomCanvasBackgroundColor: Plugin<
  keyof ChartTypeRegistry,
  AnyObject
> = {
  id: "customCanvasBackgroundColor",
  beforeDraw(chart, args, options) {
    const { ctx } = chart;
    ctx.save();
    ctx.globalCompositeOperation = "destination-over";
    ctx.fillStyle =
      options.color ||
      this.generalSettings?.backgroundColor ||
      BaseChartSettings.defaults.backgroundCanvasColor;
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  },
  defaults: {
    color: "white",
  },
};
